/**
 * Created by dell on 2017/8/11.
 */
/* eslint-disable */
import axios from 'axios'
// console.log(axios.defaults.baseURL)
export default {
  get (url, params, callBack) {//get通用方法
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params,
        headers: { 'appid': 'IF03-0618', 'apptoken': '$2a$06$mSyU0gsqkhuzOYdaTsLvkuyUPiRL6alpw2sqXmzE6ISdIoupAnz16' }
      }).then((res) => {
        // console.log(res);
        var data = res.data
        if (data) {
          if (callBack) {
            callBack(resolve, reject, data);
          } else {
            resolve(data)
          }
          resolve(data);
        } else {
        	reject(400)
        }
      }).catch(() => {
        reject(401);
      });
    });
  },
  post (url, params, callBack) {//post普通方法（后台仅能通过@requestBody获取，改良可以使用方法post2） 	
    return new Promise((resolve, reject) => {
      axios.post(url, params, {headers: { 'appid': 'IF03-0618', 'apptoken': '$2a$06$mSyU0gsqkhuzOYdaTsLvkuyUPiRL6alpw2sqXmzE6ISdIoupAnz16' }}).then((res) => {
        var data = res.data;
        if (data) {
          if (callBack) {
            callBack(resolve, reject, data);
          } else {
            resolve(data);
          }
          resolve(data);
        } else {
          reject(400);
        }
      }).catch((e) => {
        reject(e);
      });
    });
  },
  delete (url, params, callBack) {
  	return new Promise((resolve, reject) => {
      axios({
      	method: 'delete',
      	url: url, 
      	data: params,
      	headers: { 'appid': 'IF03-0618', 'apptoken': '$2a$06$mSyU0gsqkhuzOYdaTsLvkuyUPiRL6alpw2sqXmzE6ISdIoupAnz16' }
      	}).then((res) => {
        // console.log(res);
        var data = res.data;
        if (data) {
          if (callBack) {
            callBack(resolve, reject, data);
          } else {
            resolve(data);
          }
          resolve(data);
        } else {
          reject(400);
        }
      }).catch(() => {
        reject(401);
      });
    });
  },
  posthq (url, params, callBack) {//post修改方案 
    return new Promise((resolve, reject) => {
      axios.post(url, params,
        {
          transformRequest:[
              function(data){
                  let transObj='';
                  for(let i in data){
                      transObj+=i+'='+data[i]+'&';
                  }
                  return transObj;
              }
          ]
        }
      ).then((res) => {
        // console.log(res);
        var data = res.data;
        if (data) {
          if (callBack) {
            callBack(resolve, reject, data);
          } else {
            resolve(data);
          }
          resolve(data);
        } else {
          reject(400);
        }
      }).catch(() => {
        reject(401);
      });
    });
  }
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/servers/promis.js